<template>
  <div>
    <span>{{ message.message }}</span>

    <div class="categories">
      <div
        class="item"
        :class="{ 'selected-item': message.selectedOption === PredefinedOptionType.CONNECT_TO_SUPPORT }"
        @click="buildEvent(PredefinedOptionType.CONNECT_TO_SUPPORT)"
      >
        <span class="icon-left">
          <LikeIcon /> {{ $t('global.yes') }}, {{ $t('chat.sys.msg.pre_support_prompt.need_more_help') }}
        </span>
      </div>

      <div
        class="item"
        :class="{ 'selected-item': message.selectedOption === PredefinedOptionType.NO_OTHER_ISSUE }"
        @click="buildEvent(PredefinedOptionType.NO_OTHER_ISSUE)"
      >
        <span class="icon-left">
          <CustomerSupportIcon /> {{ $t('global.no') }}, {{ t('global.other_issue', 'Other issue') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { PredefinedOptionType, SystemEvent } from '@/common/bot/enum';
import { BaseSystemMessage, PredictiveSuggestionSelectionEvent } from '@/common/bot/types';
import CustomerSupportIcon from '@/components/icons/CustomerSupportIcon.vue';
import FaAngleRight from '@/components/icons/FaAngleRight.vue';
import LikeIcon from '@/components/icons/LikeIcon.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    FaAngleRight,
    CustomerSupportIcon,
    LikeIcon,
  },
})
export default class PreSupportConfirmation extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: BaseSystemMessage;

  readonly PredefinedOptionType = PredefinedOptionType;

  buildEvent(selected: PredictiveSuggestionSelectionEvent['payload']['selected']) {
    const event: PredictiveSuggestionSelectionEvent = {
      type: SystemEvent.PREDICTIVE_SUGGESTION_SELECTION,
      message: this.message,
      payload: { selected },
    };

    this.$emit('send:event', event);
  }
}
</script>

<style scoped lang="scss">
@import './ActionButtonCommon.scss';
</style>
